import { useApplicationRestartReviewMutation } from "../../../services/graphql/api";
import { getApplDetailParams } from "../../../util/functions";
import MenuDialogBase from "./MenuDialogBase";

export default function DialogRestart({ menuItemAndClose }) {
    const [apiCall, result] = useApplicationRestartReviewMutation();
    const buttons = [{ label: "Restart", apiCall, result, variablesFn: getApplDetailParams }];
    const extraContent = <></>;

    return (
        <MenuDialogBase menuItemAndClose={menuItemAndClose}
            apiCall={apiCall}
            buttons={buttons}
            result={result}
            extraContent={extraContent}
        />
    );
}